import { useFormContext, useWatch } from 'react-hook-form';
import { DealBuilderFormValues, DealBuilderSummary } from '../types';

export const useDealBuilderSummary = (): DealBuilderSummary => {
  const { control } = useFormContext<DealBuilderFormValues>();

  const customerDepositAmount = useWatch({ control, name: 'pricing.customerDeposit.amount' });

  // hardCost/feesAndTaxes/tradeIn will subscribe to their specific fields once Equipment/Pricing steps are built
  const hardCost = 0;
  const feesAndTaxes = 0;
  const tradeIn = 0;
  const balanceDue = hardCost + feesAndTaxes - customerDepositAmount - tradeIn;

  return { hardCost, feesAndTaxes, customerDeposit: customerDepositAmount, tradeIn, balanceDue };
};
